import React, { useMemo } from "react";
import { graphql, useLazyLoadQuery } from "react-relay";
import { WidgetWeather } from "widgets";
import { LazyQueryNetworkBoundrary } from "../../../../../components/mobile/QueryNetworkBoundrary";
import { WidgetSizeT } from "../../localTypes/WidgetSizeT";
import { WAWeatherPreviewQuery } from "./__generated__/WAWeatherPreviewQuery.graphql";

type Props = {
  location:
    | {
        lat: number;
        lng: number;
      }
    | string;
  size: WidgetSizeT;
  storecastId: string;
};

export function WAWeatherPreview(props: Props) {
  return (
    <LazyQueryNetworkBoundrary>
      {(fetchKey) => <InnerWAWeatherPreview {...props} fetchKey={fetchKey} />}
    </LazyQueryNetworkBoundrary>
  );
}

function InnerWAWeatherPreview(props: Props & { fetchKey: string }) {
  const widgetWeatherSize = useMemo(
    () => (props.size.w === 2 ? "TWO_X_ONE" : "ONE_X_ONE"),

    [props.size.w]
  );

  const d =
    typeof props.location === "string"
      ? { placeId: props.location }
      : {
          lat: props.location.lat,
          lng: props.location.lng,
        };
  const data = useLazyLoadQuery<WAWeatherPreviewQuery>(
    graphql`
      query WAWeatherPreviewQuery(
        $input: PreviewWidgetWeatherInput!
        $storecastId: ID!
      ) {
        dashboard(id: $storecastId) @required(action: THROW) {
          previewWidgetWeather(input: $input) {
            ...WidgetWeather_widget
          }
        }
      }
    `,
    {
      storecastId: props.storecastId,
      input: {
        ...d,
        size: widgetWeatherSize,
      },
    },
    { fetchKey: props.fetchKey, fetchPolicy: "store-and-network" }
  );

  return (
    <WidgetWeather
      widget={data.dashboard.previewWidgetWeather}
      clientForceSize={widgetWeatherSize}
      storecastId={props.storecastId}
      mode="IDLE"
    />
  );
}
